import { render, staticRenderFns } from "./CampusMood.vue?vue&type=template&id=a042a356&scoped=true"
import script from "./CampusMood.vue?vue&type=script&lang=js"
export * from "./CampusMood.vue?vue&type=script&lang=js"
import style0 from "./CampusMood.vue?vue&type=style&index=0&id=a042a356&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a042a356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a042a356')) {
      api.createRecord('a042a356', component.options)
    } else {
      api.reload('a042a356', component.options)
    }
    module.hot.accept("./CampusMood.vue?vue&type=template&id=a042a356&scoped=true", function () {
      api.rerender('a042a356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/CampusMood.vue"
export default component.exports